import { render, staticRenderFns } from "./ReportIndex.vue?vue&type=template&id=680fed78&"
import script from "./ReportIndex.vue?vue&type=script&lang=js&"
export * from "./ReportIndex.vue?vue&type=script&lang=js&"
import style0 from "./ReportIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports